export default [
  {
    path: '/mcp_create_wallet',
    name: 'CreateWalletView',
    component: () =>
      import(/* webpackChunkName: "mpc" */ '@/views/MPC/CreateWalletView.vue'),
    meta: { title: 'Create Wallet', group: 'mpc' },
  },
  {
    path: '/mcp_issue_transaction',
    name: 'IssueTransactionView',
    component: () =>
      import(
        /* webpackChunkName: "mpc" */ '@/views/MPC/IssueTransactionView.vue'
      ),
    meta: { title: 'Issue Transaction', group: 'mpc' },
  },
  {
    path: '/mcp_waiting_approval',
    name: 'WaitingApprovalView',
    component: () =>
      import(
        /* webpackChunkName: "mpc" */ '@/views/MPC/WaitingApprovalView.vue'
      ),
    meta: { title: 'Waiting Approval', group: 'mpc' },
  },
  {
    path: '/mcp_transfer_history',
    name: 'TransferHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "mpc" */ '@/views/MPC/TransferHistoryView.vue'
      ),
    meta: { title: 'Transfer History', group: 'mpc' },
  },
  {
    path: '/mcp_register_address',
    name: 'RegisterAddressView',
    component: () =>
      import(
        /* webpackChunkName: "mpc" */ '@/views/MPC/RegisterAddressView.vue'
      ),
    meta: { title: 'Register Address', group: 'mpc' },
  },
]
